export default __webpack_public_path__ + "static/media/collections_4.afcb218a.jpg";